import {ShortReservation} from '@chekin/core';

function shouldHideButton(
  checkoutFlowStatus: ShortReservation['check_out_flow_status'],
  isSurveyFlowEnabled?: boolean,
  isTotalAmountToPayZero?: boolean,
) {
  if (checkoutFlowStatus === 'FEEDBACK_SUBMITTED') {
    return true;
  }
  if (isSurveyFlowEnabled && isTotalAmountToPayZero) {
    return checkoutFlowStatus === 'NOT_STARTED';
  }

  if (isTotalAmountToPayZero) {
    return true;
  }

  return false;
}
export {shouldHideButton};
